import { Injectable } from '@angular/core';
import Keycloak, { KeycloakLoginOptions, KeycloakProfile } from 'keycloak-js';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private keycloak = new Keycloak(environment.keycloak);

  get instance(): Keycloak {
    return this.keycloak;
  }

  get authenticated(): boolean {
    return !!this.keycloak.authenticated;
  }

  get token(): string | undefined {
    return this.keycloak.token;
  }

  async init(): Promise<boolean> {
    // Optional callbacks must be set before init()
    this.keycloak.onTokenExpired = async () => {
      try {
        await this.keycloak.updateToken(30);
      } catch {
        await this.login();
      }
    };

    return this.keycloak.init({
      onLoad: 'login-required',
      pkceMethod: 'S256',
      //silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
      checkLoginIframe: false
    });
  }

  login(options?: KeycloakLoginOptions): Promise<void> {
    return this.keycloak.login(options);
  }

  logout(): Promise<void> {
    return this.keycloak.logout({
      redirectUri: window.location.origin,
    });
  }

  async getProfile(): Promise<KeycloakProfile> {
    return this.keycloak.loadUserProfile();
  }

  async refreshToken(minValidity = 30): Promise<boolean> {
    return this.keycloak.updateToken(minValidity);
  }

  hasRealmRole(role: string): boolean {
    return this.keycloak.hasRealmRole(role);
  }

  hasResourceRole(role: string, resource?: string): boolean {
    return this.keycloak.hasResourceRole(role, resource);
  }
}